export const AGENTS_GET_USER_AGENTS = 'AGENTS_GET_USER_AGENTS';
export const AGENTS_GET_CLOUD_AGENTS = 'AGENTS_GET_CLOUD_AGENTS';
export const AGENTS_FETCHING = 'AGENTS_FETCHING';
export const AGENTS_FAIL = 'AGENTS_FAIL';
export const AGENTS_SUCCESS = 'AGENTS_SUCCESS';
export const AGENTS_GET_TOKEN = 'AGENTS_GET_TOKEN';
export const AGENTS_GET_TOOLS = 'AGENTS_GET_TOOLS';
export const AGENTS_CREATE_WIZARD_RESET = 'AGENTS_CREATE_WIZARD_RESET';
export const AGENTS_CREATE_WIZARD_ADD_TOOL = 'AGENTS_CREATE_WIZARD_ADD_TOOL';
export const AGENTS_CREATE_WIZARD_REMOVE_TOOL = 'AGENTS_CREATE_WIZARD_REMOVE_TOOL';
export const AGENTS_CREATE_WIZARD_SET_FIELDS_TOOL = 'AGENTS_CREATE_WIZARD_SET_FIELDS_TOOL';
export const AGENTS_GET_MANIFEST = 'AGENTS_GET_MANIFEST';
export const RESET_NEW_AGENT = 'RESET_NEW_AGENT';
export const SET_NEW_AGENT = 'SET_NEW_AGENT';

export const AGENTS_RUN_SET_WORKSPACES = 'AGENTS_RUN_SET_WORKSPACES';
export const AGENTS_RUN_SET_RESOLVE_HOSTNAME = 'AGENTS_RUN_SET_RESOLVE_HOSTNAME';

export const AGENT_SELECTED = 'AGENT_SELECTED';
export const AGENT_UNSELECTED = 'AGENT_UNSELECTED';
export const NEW_PIVOT = 'NEW_PIVOT';
export const SELECT_ALL_AGENT = 'SELECT_ALL_AGENT';
export const UNSELECT_ALL_AGENT = 'UNSELECT_ALL_AGENT';
export const TOGGLE_AGENTS_TAB = 'TOGGLE_AGENTS_TAB';
export const AGENTS_RESET_STATE = 'AGENTS_RESET_STATE';

export const GET_USER_AGENT_REQUEST = 'GET_USER_AGENT_REQUEST';
export const GET_USER_AGENT_SUCCESS = 'GET_USER_AGENT_SUCCESS';
export const GET_USER_AGENT_FAIL = 'GET_USER_AGENT_FAIL';
export const AGENTS_SET_TOOL_SELECTED = 'AGENTS_SET_TOOL_SELECTED';
export const SAVE_AGENT_TOOL_DATA_SUCCESS = 'SAVE_AGENT_TOOL_DATA_SUCCESS';

export const GET_AGENT_EXECUTIONS = 'GET_AGENT_EXECUTIONS';
export const MULTIPLE_AGENT_EXECUTIONS_SET_SELECTED = 'MULTIPLE_AGENT_EXECUTIONS_SET_SELECTED';
export const AGENT_EXECUTIONS_SET_SELECTED = 'AGENT_EXECUTIONS_SET_SELECTED';
export const GET_RESULT_EXECUTIONS = 'GET_RESULT_EXECUTIONS';
export const UNSELECT_ALL_AGENTS_EXECUTIONS = 'UNSELECT_ALL_AGENTS_EXECUTIONS';
export const UNSELECT_AGENTS_EXECUTIONS = 'UNSELECT_AGENTS_EXECUTIONS';
export const SELECT_ALL_AGENT_EXECUTIONS = 'SELECT_ALL_AGENT_EXECUTIONS';
export const AGENTS_SET_SUCCESS = 'AGENTS_SET_SUCCESS';
export const AGENTS_CLEAR_SUCCESS = 'AGENTS_CLEAR_SUCCESS';
export const AGENTS_RESET_DETAIL = 'AGENTS_RESET_DETAIL';
export const AGENTS_DETAIL_SET_RESOLVE_HOSTNAME = 'AGENTS_DETAIL_SET_RESOLVE_HOSTNAME';
export const RESET_RESULT_EXECUTIONS = 'RESET_RESULT_EXECUTIONS';
export const AGENTS_DETAIL_SET_SEVERITY_RANGE = 'AGENTS_DETAIL_SET_SEVERITY_RANGE';
export const AGENTS_RUN_SET_SEVERITY_RANGE = 'AGENTS_RUN_SET_SEVERITY_RANGE';
export const SET_AGENTS_ENTITY = 'SET_AGENTS_ENTITY';
